/* eslint quotes: "off" */
import $ from "jquery";

// Sound mapping based on modal ID
const modalSounds = {
  modalLevels: "/static/sounds/levelup.mp3",
  modalPostgame: "/static/sounds/postgame.mp3",
  // Add other modals and their sounds here
  // modalAchievements: "../sounds/achievement.mp3"
};

// Function to open a modal and play its associated sound based on its ID
function openModalWithSound($modal) {
  const modalId = $modal.attr('id'); // Get the ID of the modal

  $modal.addClass('show');
  $('body').addClass('no-scroll');

  // Check if a sound is defined for this modal ID in the modalSounds object
  if (modalId && modalSounds[modalId]) {
    const audio = new Audio(modalSounds[modalId]);
    audio.play().catch(error => console.log("Audio playback blocked:", error));
  }
}

// Function to close a modal
function closeAnyModal() {
  $('.modal-overlay').removeClass('show');
  $('body').removeClass('no-scroll');
}

export const openModal = () => {

  // Check if the button with class .open_with_sound exists
  if ($('.open_with_sound').length) {
    // Event listener for opening modals with sound on button click
    $('.open_with_sound').on('click', function(event) {
      event.preventDefault(); // Prevent default link behavior

      const targetModalId = $(this).data('target'); // Get target modal ID from data-target attribute
      const $targetModal = $(`#${targetModalId}`);  // Select the modal with this ID

      if ($targetModal.length) {
        openModalWithSound($targetModal); // Open modal and play sound if it exists
      } else {
        console.log(`Modal with ID ${targetModalId} does not exist on this page.`);
      }
    });
  } else {
    // Automatically open the modal on page load if .open_with_sound button does not exist
    const $modalOverlay = $('.modal-overlay'); // Replace with the default modal ID if different
    if ($modalOverlay.length) {
      openModalWithSound($modalOverlay); // Open modal and play sound immediately
    }
  }
};

export const closeModal = () => {
  // $(".close_modal").on("click", closeAnyModal);

  // Close modal when clicking outside the content area
  $('.modal-overlay').on('click', function(event) {
    if ($(event.target).is('.modal-overlay')) {
      closeAnyModal();
    }
  });

  $(".close_modal").each(function() {
    $(this).on("click", function() {
      closeAnyModal();
    });
  });

  $(".close-btn").each(function() {
    $(this).on("click", function() {
      closeAnyModal();
    });
  });
};

export const hoverMenuItems = () => {
  // HOVER MENU ITEMS
  const items = [
    { element: '#languageIcon', defaultSrc: '/static/images/menu/language.svg', hoverSrc: '/static/images/menu/language_selected.svg' },
    { element: '#store', defaultSrc: '/static/images/menu/store.svg', hoverSrc: '/static/images/menu/store_selected.svg' },
    { element: '#profile', defaultSrc: '/static/images/menu/profile.svg', hoverSrc: '/static/images/menu/profile_selected.svg' },
    { element: '#notification_empty', defaultSrc: '/static/images/menu/notification_empty.svg', hoverSrc: '/static/images/menu/notification_empty_selected.svg' },
    { element: '#notification_full', defaultSrc: '/static/images/menu/notification_full.svg', hoverSrc: '/static/images/menu/notification_full_selected.svg' }
  ];

  items.forEach(({ element, defaultSrc, hoverSrc }) => {
    const $el = $(element);
    // const $langHover = element === '#languageIcon' ? $('#languageSelector') : $(element)

    $el.on('mouseenter', function() {
      $el.attr('src', hoverSrc);
    });

    $el.on('mouseleave', function() {
      if (!$el.hasClass('active')) {
        $el.attr('src', defaultSrc);
      }
    });
  });
};


export const changeSkillOption = () => {
  var $filter_skill = $('.filter_skill');
  var $offers_skill = $('.filter_list_skill .list_item')

  $filter_skill.on('click touch', '.logic', function () {
    $offers_skill.show();
    $offers_skill.filter('.logic').fadeIn(400);
  });

  $filter_skill.on('click touch', '.memory', function () {
    $offers_skill.show();
    $offers_skill.filter('.memory').fadeIn(400);
  });

  $filter_skill.on('click touch', '.attention', function () {
    $offers_skill.show();
    $offers_skill.filter('.attention').fadeIn(400);
  });
};
export const profileFullBar = () => {
  //Equal Height
  var totalProgress, progress;
  const circles = document.querySelectorAll('.progress');
  for(var i = 0; i < circles.length; i++) {
    totalProgress = circles[i].querySelector('circle').getAttribute('stroke-dasharray');
    progress = 100;
    circles[i].querySelector('.bar').style['stroke-dashoffset'] = totalProgress * progress / 100 + 502.4;
  }
};
export const closeBanner = () => {
  const bonusCloseEl = document.getElementById('bonusclose')
  if (bonusCloseEl) {
    document.getElementById('bonusclose').addEventListener('click', function (e) {
      e.preventDefault();
      this.parentNode.style.display = 'none';
    }, false);
  }
};

export const profileBar = () => {
  //Equal Height
  var totalProgress, progress;
  const circles = document.querySelectorAll('.progress');
  for(var i = 0; i < circles.length; i++) {
    totalProgress = circles[i].querySelector('circle').getAttribute('stroke-dasharray');
    progress = circles[i].parentElement.getAttribute('data-percent');
    circles[i].querySelector('.bar').style['stroke-dashoffset'] = totalProgress * progress / 100 + 502.4;
  }
};

export const equalHeightAndWidth = () => {
  //Equal Height
  var heightArray = $(".gameplay_btn").map(function () {
    return $(this).height();
  }).get();
  var maxHeight = Math.max.apply(Math, heightArray);
  $(".gameplay_btn").height(maxHeight);

  //Equal Width
  var widthArray = $(".gameplay_btn").map(function () {
    return $(this).width();
  }).get();
  var maxWidth = Math.max.apply(Math, widthArray);
  $(".gameplay_btn").width(maxWidth);
};

export const gameplayFooter = () => {
  var contentHeight = $(".gameplay_bg .container").height() + 100;
  var windowHeight = $(window).height();
  if (contentHeight >= windowHeight) {
    if ($("div").hasClass('footer_fixed')) {
      $("div").removeClass('footer_fixed');
    }
    $(".gameplay_footer ").addClass('footer_relative');
  } else {
    if ($("div").hasClass('footer_relative')) {
      $("div").removeClass('footer_relative');
    }
    $(".gameplay_footer").addClass('footer_fixed');
  }
};

export const chevronDownloop = () => {
  $('.claim_prize_img').animate({'top': '0'}, {
    duration: 350,
    complete: function () {
      $('.claim_prize_img').animate({
        duration: 1000,
        top: '+=375',
        height: '+=50px',
        width: '+=50px'
      });
    }
  });
};

export const startProgressBar = () => {
  let totalProgress, progress;
  const circles = document.querySelectorAll('.progress');
  for (let i = 0; i < circles.length; i++) {
    totalProgress = circles[i].querySelector('circle').getAttribute('stroke-dasharray');
    progress = circles[i].parentElement.getAttribute('data-percent');

    circles[i].querySelector('.bar').style['stroke-dashoffset'] = totalProgress * progress / 100 + 502.4;
  }
};
export const handleLanguageDropdown = () => {
  $('#languageSelector').click(function () {
    $('.language-dropdown').stop().toggleClass("active");
    $('#languageIcon').stop().toggleClass("rotate");
    $('#chevronIcon').stop().toggleClass("rotate");

    if ($('.language-dropdown').hasClass('active')) {
      $('#languageIcon').attr('src', '/static/images/menu/language_selected.svg');
    } else {
      $('#languageIcon').attr('src', '/static/images/menu/language.svg');
    }
  });
  $(document).on('click', function (event) {
    if (!$('#languageSelector').is(event.target) && $('#languageSelector').has(event.target).length === 0) {
      $('.language-dropdown').removeClass("active");
      $('#languageIcon').removeClass("rotate");
      $('#chevronIcon').removeClass("rotate");
      $('#languageIcon').attr('src', '/static/images/menu/language.svg');
    }
  });
};

export const draw = (id, percen) => {
  drawElement(percen);
  function drawElement(percentage) {
    var circle = $('#green-halo_' + id);
    var perc = $('#perc_' + id);
    console.log(circle);
    console.log(perc);

    var interval = 15;
    var angle = 0;
    var angle_increment = 6;

    const interval1 = window.setInterval(function () {
      circle.attr("stroke-dasharray", angle + ", 360");
      perc.html(percentage + '%');
      if (angle >= (percentage*360/100)) {
        window.clearInterval(interval1);
        fillCirc(angle);
      }

      angle += angle_increment;
    }.bind(this), interval);
  }
  function fillCirc(circ_percentage) {
    var circle = $('#green-halo_' + id);
    console.log(circle);
    circle.attr('stroke-dasharray', '0, 360');
    $({countValue:0}).animate(
      {countValue: 270},
      {
        duration: 1000,
        easing:'easeOutBounce',
        step: function (value) {
          circle.attr("stroke-dasharray", circ_percentage + ", 360");
        }
      }
    );
  }
};

export const loading = () => {
  setTimeout(() => {
    document.querySelectorAll(".bar").forEach((current) => {
      let startWidth = 0;
      const endWidth = current.dataset.size;
      if (endWidth) {
        const interval = setInterval(() => {
          if (startWidth >= endWidth) {
            clearInterval(interval);
          } else {
            startWidth++;
            current.style.width = `${endWidth}%`;
            current.firstElementChild.innerText = `${startWidth}%`;
          }
        }, 20);
      }
    });
  }, 1000);
};

export const handleLang = () => {
  $('.nav__toggle.nav__toggle_lang').click(function(e) {
    e.preventDefault();
    if (!$('.nav__toggle.nav__toggle_lang').hasClass( "active")){
      //CLEAN
      $('.nav-dropdown.nav_dropdown_lang').hide(10);
      $('.nav-dropdown.nav_dropdown_burgerMenu').hide(10);
      $('.nav__toggle.nav__toggle_lang').removeClass( "active");
      $('.nav__toggle.nav__toggle_burgerMenu').removeClass( "active");
      $('#nav_dropdown_lang').hide(10);
      $('.black-overlay').hide(10);
      // CLEAN END

      $('.nav__toggle.nav__toggle_lang').addClass( "active");
      $('.nav-dropdown.nav_dropdown_lang').show(200);
      $('.black-overlay').show(200);
    }
  });
};

export const handleBurgerMenuActiveChoice = () => {
  $('#nav_dropdown_burgerMenu li a').click(function(e) {
    $("#nav_dropdown_burgerMenu li a").removeClass("active");
    $(this).addClass("active");

    $('.nav__toggle.nav__toggle_burgerMenu').removeClass('active');
    $('.nav__toggle.nav__toggle_lang').removeClass('active');
    $('.black-overlay').hide(500);
    $('#nav_dropdown_user, #nav_dropdown_burgerMenu, #nav_dropdown_notif, #nav_dropdown_lang, #get_started_menu').stop().fadeOut(200);
  });
};

export const handleLangMenuActiveChoice = () => {
  $('#nav_dropdown_lang li a').click(function(e) {
    $("#nav_dropdown_lang li a").removeClass("active");
    $(this).addClass("active");

    $('.nav__toggle.nav__toggle_burgerMenu').removeClass('active');
    $('.nav__toggle.nav__toggle_lang').removeClass('active');
    $('.black-overlay').hide(500);
    $('#nav_dropdown_user, #nav_dropdown_burgerMenu, #nav_dropdown_notif, #nav_dropdown_lang, #get_started_menu').stop().fadeOut(200);
  });
};
export const handleBurger = () => {
  $('#menuToggle').on('click', function() {
    $(this).toggleClass('active');
    $('#navMenu').toggleClass('active');
    if ($('#navMenu').hasClass('active')) {
      $('body').css('overflow', 'hidden');
    } else {
      $('body').css('overflow', 'auto');
    }
  });
  $('#navMenu .menu_open_top a, .logo a, .header_right a').on('click', function () {
    $('#menuToggle').removeClass('active');
    $('#navMenu').removeClass('active');
    $('body').css('overflow', 'auto');
  });
};

export const openCloseTab = () => {
  // Close open Menu
  $('.mobile-menu__icon').click(function(e) {

    $('.mobile-menu__icon').toggleClass('open');
    $(".mobile-menu__container").toggleClass('open');
    // Stop Scrolling on page when open menu
    $("body").toggleClass("menu_open");

  });

  $(".mobile-menu__item").click(function(e){

    if ($(".mobile-menu__icon").hasClass("open")) {
      $(".mobile-menu__icon").removeClass('open');
    }
    if ($(".mobile-menu__container").hasClass("open")) {
      $(".mobile-menu__container").removeClass('open');
    }
  });
};


export const myFunction = () => {
  var element = document.getElementById("blurry");
  element.classList.toggle("blurred_bg");
}


export const squareLoaderAnimation = () => {
  // square animation
  const height = $(document).height();
  const width = $(document).width();
  const offset = 2 * width + 2 * height;
  $('.square-loader svg rect').css({'stroke-dasharray':offset, 'stroke-dashoffset':offset});
  // start the timer
  $('.square-loader').addClass('start');
};

export const randomSearchAnimation = (vueInstance) => {
  let counter = 0;
  vueInstance.timer = setInterval(() => {
    counter++;
    const random = Math.floor(Math.random()*(16-1+1)+1);
    $('.avatar-item').removeClass('active');
    $('.avatar-item:nth-child('+random+')').addClass('active');
  }, 400);
};

export const opponentFoundVSText = () => {
  const el = $('.opponent-found__vs');
  const w = el.width();
  const h = el.height();
  const $text = $('.opponent-found__vs span');
  $text.css('font-size',w/1.8);
};

export const pieChartAnimation = (selectorElement, percent) => {
  if(!$(selectorElement).length) {
    return;
  }
  const el = selectorElement;
  const donut = true;
  percent = Math.round(percent);
  if (percent > 100) {
    percent = 100;
  } else if (percent < 0) {
    percent = 0;
  }
  const deg = Math.round(360 * (percent / 100));

  if (percent > 50) {
    $(el + ' .pie').css('clip', 'rect(auto, auto, auto, auto)');
    $(el + ' .right-side').css('transform', 'rotate(180deg)');
  } else {
    $(el + ' .pie').css('clip', 'rect(0, 1em, 1em, 0.5em)');
    $(el + ' .right-side').css('transform', 'rotate(0deg)');
  }
  if (donut) {
    $(el + ' .right-side').css('border-width', '16px');
    $(el + ' .left-side').css('border-width', '16px');
    $(el + ' .shadow').css('border-width', '16px');
  } else {
    $(el + ' .right-side').css('border-width', '1.0em');
    $(el + ' .left-side').css('border-width', '1.0em');
    $(el + ' .shadow').css('border-width', '1.0em');
  }
  $(el + ' .left-side').css('transform', 'rotate(' + deg + 'deg)');
};

export const updateProgressBarGamesWon = (percent) => {
  $('#gamesWon').each(function(i, obj) {
    $(obj).width(percent+"%");
  });
};

export const updateProgressBarAnswersPercent = (percent) => {
  $('#correctAnswers').each(function(i, obj) {
    $(obj).width(percent+"%");
  });
};

export const spinTheWheel = (clicks, degree, num) => {
    //add 1 every click
    clicks ++;

    /*multiply the degree by number of clicks
     generate random number between 1 - 360,
     then add to the new degree*/
    const newDegree = degree * clicks;
    const extraDegree = Math.floor(((6 - (num + 1))*(1/6) + (1/6)) * (360 - 1 + 1)) + 1;
    const totalDegree = newDegree + extraDegree;

    /*let's make the spin btn to tilt every
     time the edge of the section hits
     the indicator*/
    $('#wheel .sec').each(function(){
      let t = $(this);
      let c = 0;
      let n = 700;
      const interval = setInterval(function () {
        c++;
        if (c === n) {
          clearInterval(interval);
        }
        let aoY = t.offset().top;
        $("#txt").html(aoY);

        /*23.7 is the minumum offset number that
         each section can get, in a 30 angle degree.
         So, if the offset reaches 23.7, then we know
         that it has a 30 degree angle and therefore,
         exactly aligned with the spin btn*/
        if (aoY < 23.89){
          $('#spin').addClass('spin');
          setTimeout(function () {
            $('#spin').removeClass('spin');
          }, 100);
        }
      }, 10);
      $('#inner-wheel').css({
        'transform' : 'rotate(' + totalDegree + 'deg)'
      });
    });
  return clicks;
};

export const stopSpinningTheWheel = () => {
  const wheel = $('#inner-wheel');
  const e = wheel.css('transform'); // get the current state
  wheel.css('transform', e);
};



// WEBPACK FOOTER //
// ./src/common/jQuery.js